(function () {
  function initMartaNavigation(navigation) {
    if (!navigation || navigation.dataset.martaNavigationReady === 'true') {
      return;
    }

    navigation.dataset.martaNavigationReady = 'true';

    const storageKey = 'marta-navigation-open-items';

    function getStoredOpenItems() {
    try {
        const stored = sessionStorage.getItem(storageKey);
        const parsed = stored ? JSON.parse(stored) : [];

        return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
        return [];
    }
    }

    function saveStoredOpenItems(keys) {
    try {
        sessionStorage.setItem(
        storageKey,
        JSON.stringify(Array.from(new Set(keys)))
        );
    } catch (error) {
        /* sessionStorage indisponível: navegação continua funcional */
    }
    }

    function rememberItemState(item, open) {
    if (!item) return;

    const key = item.dataset.navigationKey;
    if (!key) return;

    const stored = getStoredOpenItems();

    if (open) {
        if (!stored.includes(key)) {
        stored.push(key);
        }
    } else {
        const index = stored.indexOf(key);

        if (index !== -1) {
        stored.splice(index, 1);
        }
    }

    saveStoredOpenItems(stored);
    }

    function setToggleState(button, open) {
      if (!button) return;

      button.setAttribute('aria-expanded', open ? 'true' : 'false');

      const symbol = button.querySelector('span');

      if (symbol) {
        symbol.textContent = open ? '−' : '+';
      }
    }

    function openItem(item) {
      if (!item) return;

      const row = item.querySelector(':scope > .marta-navigation__row');
      const childList = row ? row.nextElementSibling : null;
      const toggle = row
        ? row.querySelector('.marta-navigation__toggle')
        : null;

      if (
        childList &&
        childList.classList.contains('marta-navigation__list')
      ) {
        childList.hidden = false;
        setToggleState(toggle, true);
      }
    }

    navigation
      .querySelectorAll('.marta-navigation__toggle')
      .forEach(function (button) {
        button.addEventListener('click', function () {
          const row = button.closest('.marta-navigation__row');
          const list = row ? row.nextElementSibling : null;

          if (!list) return;

          const opening = list.hidden;

          list.hidden = !opening;
          setToggleState(button, opening);

          const item = row.closest('.marta-navigation__item');
          rememberItemState(item, opening);
        });
      });

    const storedOpenItems = getStoredOpenItems();

    storedOpenItems.forEach(function (key) {
    const item = Array.from(
        navigation.querySelectorAll(
        '.marta-navigation__item[data-navigation-key]'
        )
    ).find(function (candidate) {
        return candidate.dataset.navigationKey === key;
    });

    if (item) {
        openItem(item);
    }
    });

    /*
    * ACTIVE COLLECTION
    *
    * O contexto automático abre apenas o caminho necessário
    * até à collection atual.
    *
    * Não fecha nenhum ramo que o utilizador tenha aberto
    * manualmente e não altera o sessionStorage.
    */

    const activeCollectionHandle =
    navigation.dataset.activeCollection || '';

    if (activeCollectionHandle) {
    const activeItem = Array.from(
        navigation.querySelectorAll(
        '.marta-navigation__item[data-collection-handle]'
        )
    ).find(function (item) {
        return (
        item.dataset.collectionHandle ===
        activeCollectionHandle
        );
    });

    if (activeItem) {
        activeItem.classList.add('is-active');

        let currentItem = activeItem;

        while (
        currentItem &&
        currentItem.classList.contains('marta-navigation__item')
        ) {
        const parentList = currentItem.parentElement;

        if (
            parentList &&
            parentList.classList.contains('marta-navigation__list')
        ) {
            parentList.hidden = false;

            const parentItem = parentList.closest(
            '.marta-navigation__item'
            );

            if (parentItem) {
            openItem(parentItem);
            currentItem = parentItem;
            continue;
            }
        }

        break;
        }
    }
    }

    /*
     * API mínima para podermos reutilizar openItem
     * quando tratarmos do active state/persistência.
     */
    navigation.martaOpenItem = openItem;
  }

  function initAllMartaNavigations() {
    document
      .querySelectorAll('[data-marta-navigation]')
      .forEach(initMartaNavigation);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initAllMartaNavigations
    );
  } else {
    initAllMartaNavigations();
  }

  document.addEventListener(
    'shopify:section:load',
    initAllMartaNavigations
  );
})();